import React, { useEffect, useMemo, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import AdLayout from "../../components/AdLayout";
import "./accountingResponsive.css";
import ReceiptVoucherList from "./ReceiptVoucherList";
import PaymentVoucherList from "./PaymentVoucherList";
import axiosInstance from "../../axiosInstance";
import {
  fetchAccountingPermissions,
  ACCOUNTING_VOUCHER_RECEIPT,
  ACCOUNTING_VOUCHER_PAYMENT,
} from "../../libs/customerCreatePermission";

const VoucherManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "receipt";
  const [canReceipt, setCanReceipt] = useState(false);
  const [canPayment, setCanPayment] = useState(false);
  const [permLoaded, setPermLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const [receipt, payment] = await Promise.all([
        fetchAccountingPermissions(axiosInstance, ACCOUNTING_VOUCHER_RECEIPT),
        fetchAccountingPermissions(axiosInstance, ACCOUNTING_VOUCHER_PAYMENT),
      ]);
      if (cancelled) return;
      setCanReceipt(Boolean(receipt?.canView));
      setCanPayment(Boolean(payment?.canView));
      setPermLoaded(true);
    })();
    return () => { cancelled = true; };
  }, []);

  const allowedTabs = useMemo(() => {
    const tabs = [];
    if (canReceipt) tabs.push("receipt");
    if (canPayment) tabs.push("payment");
    return tabs;
  }, [canReceipt, canPayment]);

  useEffect(() => {
    if (!permLoaded || allowedTabs.length === 0) return;
    if (!allowedTabs.includes(tab)) {
      const next = new URLSearchParams(searchParams);
      next.set("tab", allowedTabs[0]);
      setSearchParams(next, { replace: true });
    }
  }, [permLoaded, allowedTabs, tab, searchParams, setSearchParams]);

  const handleTabSelect = (key) => {
    if (!key || !allowedTabs.includes(key)) return;
    setSearchParams({ tab: key });
  };

  if (!permLoaded) return null;

  return (
    <AdLayout>
      <div className="acc-page">
        <h5 className="fw-bold mb-3">Phiếu thu / Phiếu chi</h5>
        <Tabs
          activeKey={allowedTabs.includes(tab) ? tab : allowedTabs[0]}
          onSelect={handleTabSelect}
          className="mb-3 acc-tabs-scroll"
        >
          {canReceipt && (
            <Tab eventKey="receipt" title="Phiếu thu">
              {tab === "receipt" && <ReceiptVoucherList embedded />}
            </Tab>
          )}
          {canPayment && (
            <Tab eventKey="payment" title="Phiếu chi">
              {tab === "payment" && <PaymentVoucherList embedded />}
            </Tab>
          )}
        </Tabs>
      </div>
    </AdLayout>
  );
};

export default VoucherManagement;
